import React, { useEffect, useState } from "react";
import { Box, Divider, Grid, Paper, Stack, TablePagination, Typography } from "@mui/material";
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { getMyExams } from '../../../common/services/myExams'
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SimulatesCards from "../../../components/SimulatesCards";
import Loading from '../../../components/Loading'
import MySimulatesSkeleton from "../../../components/SimulatesCards/components/MySimulatesSkeleton";
import Notification from "../../../components/Notification";

const MySimulates = (props) => {

    const [loading, setLoading] = useState(false); // state para controlar o erro de memory leak
    const [mySimulates, setMySimulates] = useState([]);
    const [myQuerySimulates, setMyQuerySimulates] = useState({
        page: 0,
        rowsPerPage: 6
    });

    const getUserExams = async (newQueryData) => {
        try {
            setLoading(true);
            newQueryData = newQueryData || 0

            const response = await getMyExams(myQuerySimulates, newQueryData);

            setMySimulates(response)
        } catch (e) {
            Notification.error({
                message: 'Algo deu errado.'
            })
        } finally {
            setLoading(false);
        }
    };

    const handleMySimulatesWhereDataChange = (newData) => {
        setMyQuerySimulates((currentState) => (
            {
                ...currentState,
                ...newData
            }))
    };

    const handlePageChange = async (e, page) => {
        handleMySimulatesWhereDataChange({ page });

        await getUserExams({ page })
    };

    const handleRowsPerPageChange = async (rowsPerPage) => {
        handleMySimulatesWhereDataChange({ rowsPerPage });

        await getUserExams({ rowsPerPage })
    }

    useEffect(() => {
        getUserExams();
    }, [])

    return (
        <React.Fragment>
            <Box sx={{ paddingTop: '6rem' }}>
                <Stack justifyContent="center" alignItems="center" paddingTop="15px" paddingBottom="15px">
                    <MenuBookIcon fontSize="large" sx={{ marginRight: '13px' }} />
                    <Box component="span" style={{ fontSize: '33px', fontWeight: 'bold' }}>
                        Meus Simulados
                    </Box>
                </Stack>
                <Box className="div__mysimulates">
                    <Loading loading={loading} customLoadingElement={<MySimulatesSkeleton />}>
                        <Grid container justifyContent="flex-start" alignItems="flex-start" padding="10px" spacing={3}>
                            {
                                mySimulates.count > 0
                                    ?
                                    (
                                        mySimulates.rows.map((simulate, index) => (
                                            <Grid key={index} container item xs={12} sm={6} md={4} justifyContent="center" alignItems="center">
                                                <SimulatesCards data={simulate} />
                                            </Grid>
                                        ))
                                    )
                                    :
                                    <React.Fragment>
                                        <Divider orientation="horizontal" />

                                        <Stack container justifyContent="center" alignItems="center">
                                            <Typography component="span">
                                                Nenhum <Box component="b">simulado</Box> encontrado...
                                            </Typography>
                                        </Stack>
                                    </React.Fragment>
                            }
                        </Grid>
                    </Loading>
                    {
                        mySimulates.count > 1
                            ?
                            <Grid container padding="10px">
                                <Paper sx={{ width: '100%' }}>
                                    <TablePagination
                                        sx={{
                                            '.MuiTablePagination-selectLabel': {
                                                marginBottom: '0px'
                                            },
                                            '.MuiTablePagination-displayedRows': {
                                                marginBottom: '0px'
                                            }
                                        }}
                                        component="div"
                                        rowsPerPageOptions={[3, 6, 12, 18]}
                                        count={mySimulates.count}
                                        rowsPerPage={myQuerySimulates.rowsPerPage}
                                        page={myQuerySimulates.page}
                                        onPageChange={handlePageChange}
                                        onRowsPerPageChange={({ target }) => {
                                            handleRowsPerPageChange(+target.value)
                                        }}
                                        labelRowsPerPage={'Resultados por página:'}
                                        labelDisplayedRows={(e) => `Página de ${e.page + 1} de ${Math.ceil(e.count / myQuerySimulates.rowsPerPage)} | Total de resultados: ${mySimulates.count}`}
                                    />
                                </Paper>
                            </Grid>
                            :
                            null
                    }
                </Box>
            </Box>
        </React.Fragment >
    )
}

const mapStateToProps = state => ({
    user: state.account.user
});

const MySimulatesWithRouter = withRouter(
    connect(mapStateToProps, {
    })(withRouter(MySimulates))
);

export { MySimulatesWithRouter as MySimulates }